import { PersonalityFormState } from '../types';
import templatesData from '../templates/personalities.json';

export interface Template {
  id: string;
  name: string;
  description: string;
  icon: string;
  components: string[];
  config: any;
}

export function getTemplates(): Template[] {
  return templatesData.templates.map(t => ({
    id: t.id,
    name: t.name,
    description: t.description,
    icon: t.icon,
    components: t.components,
    config: t.config
  }));
}

export function applyTemplate(template: Template): Partial<PersonalityFormState> {
  const newPersonality: Partial<PersonalityFormState> = {
    name: template.name,
    description: template.description,
    version: '1.0.0',
    language: 'en',
    ...template.config
  };

  return newPersonality;
}

